export const FONT_OPTIONS = {
  heading: ["Cormorant Garamond", "Playfair Display", "Marcellus", "EB Garamond", "Lora", "DM Serif Display"],
  body: ["Manrope", "Jost", "Montserrat", "Nunito Sans", "Work Sans", "Karla"],
};

export const DEFAULT_SECTIONS = [
  { id: "trust", label: "Trust Bar (Since 2002 etc.)", visible: true },
  { id: "categories", label: "Category Grid", visible: true },
  { id: "featured", label: "Featured Products", visible: true },
  { id: "new_arrivals", label: "New Arrivals", visible: true },
  { id: "sale", label: "Sale / Offers", visible: true },
  { id: "heritage", label: "Heritage / Our Story", visible: true },
  { id: "wholesale_cta", label: "Wholesale CTA Banner", visible: true },
];

export const DEFAULT_THEME = {
  primary_color: "#111111",
  button_text_color: "#FAF9F6",
  button_hover_color: "#D4AF37",
  secondary_color: "#D4AF37",
  background_color: "#FAF9F6",
  text_color: "#111111",
  heading_color: "#111111",
  secondary_text_color: "#555555",
  border_color: "#E5E5E5",
  card_color: "#FFFFFF",
  price_color: "#111111",
  sale_price_color: "#8A2A2B",
  header_bg: "#FAF9F6",
  footer_bg: "#111111",
  footer_text: "#FAF9F6",
  announcement_bg: "#111111",
  announcement_text: "#FAF9F6",
  announcement_enabled: true,
  header_visible: true,
  footer_visible: true,
  heading_font: "Cormorant Garamond",
  body_font: "Manrope",
  heading_size: "default",
  body_size: "default",
  letter_spacing: "default",
  line_height: "default",
  logo_url: "",
  favicon_url: "",
  hero_image: "",
  hero_mobile_image: "",
  heritage_image: "",
  hero_layout: "left",
  hero_height: "default",
  hero_fit: "cover",
  hero_position: "center",
  hero_overlay: 30,
  hero_text_align: "left",
  hero_enabled: true,
  button_size: "default",
  show_search: true,
  show_wishlist: true,
  show_account: true,
  show_cart: true,
  maintenance_mode: false,
  sections: DEFAULT_SECTIONS,
};

export const DEFAULT_NAV = [
  { label: "Shop", url: "/shop", visible: true },
  { label: "Wholesale", url: "/wholesale", visible: true },
  { label: "Our Story", url: "/about", visible: true },
  { label: "Contact", url: "/contact", visible: true },
];

export const DEFAULT_CHECKOUT = {
  guest_checkout_enabled: true,
  registration_enabled: true,
  cod_enabled: true,
  online_enabled: true,
  coupons_enabled: true,
  campaigns_enabled: true,
};

export const DEFAULT_SEO = {
  home_title: "", home_description: "",
  shop_title: "", shop_description: "",
  about_title: "", about_description: "",
  wholesale_title: "", wholesale_description: "",
  contact_title: "", contact_description: "",
  faq_title: "", faq_description: "",
  og_image: "",
  search_indexing: true,
};

export const DEFAULT_CONTENT = {
  trust_items: [
    { title: "Since 2002", text: "Two decades of craftsmanship" },
    { title: "Delhi Manufacturer", text: "Made in our own facility" },
    { title: "Wholesale & Retail", text: "Bulk orders & single pieces" },
    { title: "Trusted by Businesses", text: "Retailers, hotels & exporters" },
  ],
  categories_subheading: "Collections",
  categories_heading: "Crafted for Every Corner",
  featured_subheading: "Handpicked",
  featured_heading: "Featured Pieces",
  heritage_subheading: "Our Heritage",
  heritage_heading: "A Manufacturer, Not Just a Seller",
  heritage_paragraph: "Since 2002, Humaira Crafts has designed and manufactured premium metal home décor in our own Delhi facility. Every candle holder, bowl, tray and vase is shaped, finished and quality-checked by our artisans — which means better quality, honest pricing and reliable bulk supply for you.",
  heritage_button: "Read Our Story",
  heritage_stats: [
    { value: "20+", label: "Years" },
    { value: "500+", label: "Designs" },
    { value: "1000+", label: "Happy Buyers" },
  ],
  wholesale_cta_subheading: "For Businesses",
  wholesale_cta_heading: "Buying in Bulk? Get Manufacturer-Direct Wholesale Pricing",
  wholesale_cta_text: "Retailers, interior designers, hotels and exporters — tell us your requirements.",
  wholesale_cta_button: "Submit Bulk Enquiry",
  about_hero_kicker: "Est. 2002 · Delhi, India",
  about_hero_title: "Two Decades of Metal, Light & Craft",
  about_s1_heading: "A Manufacturer at Heart",
  about_s1_p1: "Humaira Crafts began in 2002 in Delhi with a simple belief: beautiful metal décor should be made, not just traded. Over two decades later, we remain a manufacturer first — every candle holder, lotus holder, bowl, tray and vase is designed, shaped, polished and finished in our own facility.",
  about_s1_p2: "Because we control the entire process, our customers — from individual homes to retailers, hotels and exporters — get consistent quality, honest pricing and dependable supply. That is the Humaira Crafts promise.",
  about_s2_kicker: "What We Make",
  about_s2_heading: "Premium Metal Home Décor",
  about_s2_items: "Metal Candle Holders\nLotus Candle Holders\nDecorative Bowls\nDecorative Trays\nMetal Vases\nTable Decor\nFestival Decor\nLuxury Gift Items",
  wholesale_hero_kicker: "Wholesale & Bulk Orders",
  wholesale_hero_title: "Manufacturer-Direct Pricing for Your Business",
  wholesale_hero_text: "Retailers, interior designers, hotels, corporates and exporters — share your requirements and our sales team will respond with wholesale pricing within 24 hours.",
  wholesale_benefits_heading: "Why Businesses Choose Us",
  wholesale_benefits: [
    { title: "Manufacturer Direct", text: "No middlemen. You buy straight from our Delhi facility." },
    { title: "Wholesale Pricing", text: "Volume-based pricing shared after your enquiry." },
    { title: "Consistent Quality", text: "Every batch quality-checked, since 2002." },
    { title: "Reliable Supply", text: "Bulk production capacity with dependable timelines." },
  ],
  wholesale_form_heading: "Submit Your Requirements",
  contact_heading: "Contact Us",
  footer_text: "Premium metal home décor, manufactured in Delhi since 2002. Wholesale & retail.",
  copyright_text: "© {year} Humaira Crafts. All rights reserved.",
  maintenance_message: "We are currently performing scheduled maintenance. Please check back soon.",
  hero_primary_text: "Shop Collection",
  hero_primary_link: "/shop",
  hero_secondary_text: "Wholesale Enquiry",
  hero_secondary_link: "/wholesale",
  faq_items: [
    { q: "Are you a manufacturer or a reseller?", a: "We are a manufacturer. Humaira Crafts has been producing premium metal home décor in our own Delhi facility since 2002. Buying from us means manufacturer-direct quality and pricing." },
    { q: "Do you accept wholesale / bulk orders?", a: "Yes. We supply retailers, interior designers, hotels, corporates and exporters. Submit a wholesale enquiry and our sales team will share volume pricing within 24 hours." },
    { q: "What payment methods do you accept?", a: "We accept UPI, credit/debit cards, net banking and wallets via Razorpay, as well as Cash on Delivery (COD)." },
    { q: "How long does delivery take?", a: "Orders are typically delivered within 5-7 business days across India. Bulk orders may take longer depending on quantity — our team will confirm timelines." },
    { q: "How are shipping charges calculated?", a: "Shipping charges are calculated during checkout or confirmed after your order, based on weight and destination." },
    { q: "Can I track my order?", a: "Yes. Use the Track Order page with your order number and email. You will also receive email updates as your order progresses." },
    { q: "What is your return policy?", a: "We accept returns for damaged or defective items reported within 48 hours of delivery. See our Return & Refund Policy for full details." },
    { q: "Do you ship outside India?", a: "For international and export orders, please submit a wholesale enquiry and our team will assist you." },
  ],
  policy_privacy: "## Information We Collect\nWhen you place an order or create an account, we collect your name, email, phone number and delivery address. This information is used solely to process your orders and communicate with you.\n\n## How We Use Your Information\nYour details are used for order processing, delivery, customer support and order-related updates. We do not sell or share your personal information with third parties for marketing.\n\n## Payment Security\nOnline payments are processed securely by Razorpay. We never store your card, UPI or banking details on our servers.\n\n## Data Retention\nOrder records are retained for business and legal compliance. You may request deletion of your account data by contacting us.\n\n## Contact\nFor any privacy concerns, reach us through our Contact page.",
  policy_returns: "## Damaged or Defective Items\nIf your order arrives damaged or defective, report it within 48 hours of delivery with photographs. We will arrange a replacement or full refund.\n\n## Eligibility\nItems must be unused and in original packaging. Custom or bulk-manufactured orders are not eligible for return unless defective.\n\n## Refund Process\nApproved refunds are processed within 5-7 business days to the original payment method. COD orders are refunded via bank transfer.\n\n## Cancellations\nOrders can be cancelled before dispatch for a full refund. Contact us as early as possible with your order number.",
  policy_shipping: "## Delivery Time\nOrders are typically delivered within 5-7 business days across India. Bulk and made-to-order quantities may require additional time, which our team will confirm.\n\n## Shipping Charges\nShipping charges are calculated during checkout or confirmed after your order, based on weight, dimensions and destination.\n\n## Packaging\nAll metal décor is securely packed with protective material to ensure it reaches you in perfect condition.\n\n## Order Tracking\nYou will receive email updates as your order is confirmed, shipped and delivered. You can also track anytime on our Track Order page.",
  policy_terms: "## General\nBy using this website and placing an order, you agree to these terms. Humaira Crafts is a Delhi-based manufacturer of premium metal home décor, operating since 2002.\n\n## Products & Pricing\nWe strive for accuracy in product descriptions, images and pricing. As each piece is handcrafted, minor variations in finish and dimensions are natural and part of the craft.\n\n## Orders\nAn order is confirmed once payment is received (online) or the order is placed (COD). We reserve the right to cancel orders in case of stock unavailability, with a full refund.\n\n## Wholesale\nWholesale pricing is provided on enquiry and is subject to minimum order quantities and separate terms communicated by our sales team.\n\n## Liability\nOur liability is limited to the value of the order placed. We are not liable for indirect or consequential losses.",
};

export function hexToHsl(hex) {
  let h = (hex || "").replace("#", "");
  if (h.length === 3) h = h.split("").map((c) => c + c).join("");
  const r = parseInt(h.slice(0, 2), 16) / 255;
  const g = parseInt(h.slice(2, 4), 16) / 255;
  const b = parseInt(h.slice(4, 6), 16) / 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let hh = 0, s = 0;
  const l = (max + min) / 2;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    if (max === r) hh = (g - b) / d + (g < b ? 6 : 0);
    else if (max === g) hh = (b - r) / d + 2;
    else hh = (r - g) / d + 4;
    hh *= 60;
  }
  return `${Math.round(hh)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
}

const H1_SIZES = { small: "2.25rem", default: "3rem", large: "3.75rem" };
const BODY_SIZES = { small: "0.875rem", default: "1rem", large: "1.0625rem" };
const BTN_SIZES = { small: "0.625rem", default: "0.75rem", large: "0.875rem" };
const LETTER_SPACING = { tight: "-0.02em", default: "0", wide: "0.03em" };
const LINE_HEIGHTS = { compact: "1.4", default: "1.625", relaxed: "1.9" };

export function applyTheme(t) {
  if (!t) return;
  const root = document.documentElement;
  root.style.setProperty("--gold", t.secondary_color);
  root.style.setProperty("--gold-muted", t.secondary_color);
  root.style.setProperty("--background", hexToHsl(t.background_color));
  root.style.setProperty("--foreground", hexToHsl(t.text_color));

  let el = document.getElementById("theme-overrides");
  if (!el) {
    el = document.createElement("style");
    el.id = "theme-overrides";
    document.head.appendChild(el);
  }
  el.textContent = `
    body { background-color: ${t.background_color}; color: ${t.text_color}; font-family: '${t.body_font}', sans-serif; font-size: ${BODY_SIZES[t.body_size] || BODY_SIZES.default}; line-height: ${LINE_HEIGHTS[t.line_height] || LINE_HEIGHTS.default}; letter-spacing: ${LETTER_SPACING[t.letter_spacing] || "0"}; }
    h1, h2, h3, h4, .font-serif { font-family: '${t.heading_font}', serif !important; }
    h1, h2, h3, h4 { color: ${t.heading_color}; }
    h1 { font-size: ${H1_SIZES[t.heading_size] || H1_SIZES.default}; }
    .font-sans { font-family: '${t.body_font}', sans-serif !important; }
    .text-muted-foreground { color: ${t.secondary_text_color} !important; }
    .bg-\\[\\#111\\] { background-color: ${t.primary_color} !important; color: ${t.button_text_color} !important; }
    .hover\\:bg-\\[\\#111\\]:hover { background-color: ${t.primary_color} !important; }
    .hover\\:text-\\[\\#FAF9F6\\]:hover { color: ${t.button_text_color} !important; }
    .hover\\:bg-gold:hover { background-color: ${t.button_hover_color} !important; }
    .border-black\\/10, .border-black\\/15, .border-black\\/20 { border-color: ${t.border_color} !important; }
    .bg-white { background-color: ${t.card_color} !important; }
    [data-testid^="price-"] .font-semibold { color: ${t.price_color} !important; }
    [data-testid^="sale-badge-"] { background-color: ${t.sale_price_color} !important; }
    .small-caps { font-size: ${BTN_SIZES[t.button_size] || BTN_SIZES.default} !important; }
  `;

  if (t.favicon_url) {
    let fav = document.querySelector('link[rel="icon"]');
    if (!fav) {
      fav = document.createElement("link");
      fav.rel = "icon";
      document.head.appendChild(fav);
    }
    fav.href = t.favicon_url.startsWith("/api") ? `${t.favicon_url}` : t.favicon_url;
  }

  const fams = [...new Set([t.heading_font, t.body_font])]
    .map((f) => f.replace(/ /g, "+") + ":wght@300;400;500;600;700")
    .join("&family=");
  let link = document.getElementById("theme-fonts");
  if (!link) {
    link = document.createElement("link");
    link.id = "theme-fonts";
    link.rel = "stylesheet";
    document.head.appendChild(link);
  }
  link.href = `https://fonts.googleapis.com/css2?family=${fams}&display=swap`;
}
